import { languages } from "../../../dummyData/dummyData";
import TileItemInfo from "../../molecules/TileItemInfo/TileItemInfo";
import TileItemImgInfo from "../../molecules/TileItemImgInfo/TileItemImgInfo";
import TileItem from "../TileItem/TileItem";
import { generatePath, useHistory } from "react-router-dom";
import { Routes } from "../../../routes";
import { ACTIONS, PopupsContext } from "../../../contexts/PopupsContext";
import { popupFields } from "../JobPositionsList/JobPositionsList";
import { useContext } from "react";
import { jobPositionsRepository } from "../../../repository/jobPositions.repository";
import { UserContext } from "../../../contexts/UserContext";

const JobPositionTile = ({ data, withManagement }) => {
  const { id, profile_image_small, name, topic, country, level, num_org_members, num_team_members, visibility, visibilityImg, active, canEdit } = data;
  const { callPopup } = useContext(PopupsContext);
  const { userContextLevel } = useContext(UserContext);
  let history = useHistory();

  return (
    <TileItem title={name} subtitle={`${languages.EN.labels.region}: ${country}`} image={profile_image_small} inactive={!active} buttons={[].concat(canEdit ? [
      {
        icon: "edit",
        onClick: () => callPopup({
          type: ACTIONS.FORM,
          payload: {
            header: `${languages.EN.labels.edit} ${languages.EN.labels.jobPosition}`,
            fields: popupFields(data),
            postAction: (formData) => jobPositionsRepository.editJobPosition(id, formData),
          },
        }),
        tooltip: languages.EN.labels.edit,
      },
    ] : []).concat(withManagement === true && [2, 3].includes(userContextLevel) ? [
      {
        icon: "clone",
        onClick: () => callPopup({
          type: ACTIONS.FORM,
          payload: {
            header: `${languages.EN.labels.clone} ${languages.EN.labels.jobPosition}`,
            fields: popupFields(data),
            postAction: (formData) => {
              if (!(formData.profile_image instanceof File)) {
                formData.profile_image_url = formData.profile_image;
                delete formData.profile_image;
              }
              return jobPositionsRepository.addJobPosition(formData);
            },
          },
        }),
        tooltip: languages.EN.labels.clone,
      }
    ] : []).concat([
      {
        icon: "dots",
        onClick: () => history.push(generatePath(Routes.jobPositionDetails.keyCompetences.base, { id: id })),
        tooltip: languages.EN.labels.details,
      },
    ])}>
      <TileItemInfo header={languages.EN.labels.learningArea} value={languages.EN.enums.learningAreas[topic]} />
      <TileItemInfo header={languages.EN.labels.experienceLevel} value={languages.EN.enums.experienceLevels[level]} />
      <TileItemInfo header={languages.EN.labels.noOfOrganizationMembers} value={num_org_members} />
      <TileItemInfo header={languages.EN.labels.noOfTeamMembers} value={num_team_members} />
      <TileItemImgInfo header={languages.EN.labels.visibility} value={visibility} image={visibilityImg} />
    </TileItem>
  );
};

export default JobPositionTile;
